import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


function Navbar(props) {
    const style = {
        right: props.darkMode ? "2px" : "30px"
    };

    return (
        <div className="navbar">
            <div className="toggle" onClick={props.toggleDarkMode}>
                {props.darkMode ? <FontAwesomeIcon icon="fa-solid fa-sun" />: <FontAwesomeIcon icon="fa-solid fa-moon" />}
                <div style={style}></div>   
            </div>
        </div>
    );
}

export default Navbar;
